import hotelGroupW from './hotelGroupW';
import hotelHour from './hotelHour';
import ddr from './ddr';
import food from './food';
import sight from './sight';
import vacation from './vacation';
import hotelSight from './hotelSight';
import bnb from './bnb';
import carcar from './carcar';
import flight from './flight';
import scenerycar from './scenerycar';
import huiyi from './huiyi';
import hotel from './hotel';
import bus from './bus/index';
import transfercar from './transferCar';
import qmall from './qmall';
import supermall from './supermall';
import shopping from './shopping';
import train from './train';
import waimai from './waiMai';
import pack from './pack';
import qstar from './qstar';

const businessClassMap: { [propName: string]: any } = {
    hotel,
    flight,
    train,
    bus,
    food,
    hotel_group_w: hotelGroupW,
    waimai,
    scenerycar,
    hotel_hour: hotelHour,
    qmall,
    sight,
    transfercar,
    carcar,
    huiyi,
    ddr,
    hotel_sight: hotelSight,
    vacation,
    shopping,
    pack,
    bnb,
    supermall,
    qstar
};

const businessNameMap: { [propName: string]: string } = {
    hotel: '酒店',
    flight: '机票',
    bus: '汽车票·船票',
    train: '火车票',
    food: '团购',
    hotel_group_w: '酒店-团购',
    waimai: '外卖',
    scenerycar: '景区直通车',
    hotel_hour: '钟点房',
    qmall: '旅行商城',
    sight: '门票',
    transfercar: '接送用车',
    carcar: '用车自驾',
    huiyi: '会场',
    ddr: '惠玩当地',
    hotel_sight: '酒店+门票',
    vacation: '度假',
    shopping: '全球购',
    pack: '行李寄送',
    bnb: '民宿客栈',
    supermall: '旅行商城',
    qstar: '付费会员'
};

const getComponentByBusinessType = (businessType: string) => businessClassMap[businessType] || null;

const headerTitleByBusinessType = (businessType: string) => businessNameMap[businessType] || '';
export { getComponentByBusinessType, headerTitleByBusinessType };
